import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Injectable, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, NgForm, NgModel, Validators } from '@angular/forms';
import { _ } from '@ag-grid-community/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { DialogService } from 'src/app/services/dialog.service';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { ThemeService } from 'src/app/services/theme.service';


@Injectable({
  providedIn: 'root'
})

export class VariationServices {
      
  editFace:Subject<string> = new Subject<string>();
  constructor(){

  }

  changeFace(newFace){
      this.editFace.next(newFace);
  }

  getFace(){
  }

}


export interface options{
    view:string;
    value:string;
}


@Component({
    selector: 'meli-item-variation',
    templateUrl: './meli-item-variation.component.html',
    styleUrls: ['./meli-item-variation.component.scss'],
    standalone: false
})
export class MeliItemVariationComponent implements OnInit,AfterViewInit {

  constructor(private formBuilder:UntypedFormBuilder, private http2:HTTPService,  private cd:ChangeDetectorRef,private dialogService:DialogService,
    private snackBar:SnackbarService,private uid:UserAuthenticationServices, 
    private spinner:NgxSpinnerService, public varServices:VariationServices,
    private http:HTTPService,
    private ThemeService:ThemeService) {

    this.formImagens = formBuilder.group({});
    this.filteredImages = this.imageCtrl.valueChanges.pipe(
      startWith(null),
      map((image: string | null) => (image ? this._filter(image) : this.allImages.slice())),
    );

  }

  ngAfterViewInit(): void {
    
    this.varServices.editFace.subscribe(data=>{
      this.tipo = data;
      
      if ( data == "insertFace" || data=='editFace'){
        this.face = true;
      }else{
        this.face = false;
      }
      

      if ( this.face ){

        this.currentStep = 0;
        this.getOptions('porlocal');
        this.getOptions('tabpreco');

        if ( data=="insertFace"){
          this.formVariacao.reset();
          this.formImagens.reset();
          this.selectedData = {};
          this.selectedData['images'] = [];
          this.images = [];
          this.selectedData['attribs'] = [];
        }
      }else{
        
        if ( data == "cancel"){
          this.selectedData = {};
          this.variacoes[this.selectedIndex] = this.oldSelectedData;
        }
      }
    })
  }

  
  @ViewChild('imageInput') imageInput: ElementRef<HTMLInputElement>;
  filteredImages: Observable<string[]>;
  formVariacao:UntypedFormGroup;
  formImagens:UntypedFormGroup;
  imageCtrl:UntypedFormControl = new UntypedFormControl();
  data;
  oldSelectedData;  
  dataValue:Map<String,Object> = new Map<String,Object>();
  allImages:string[] = [];
  currentStep = 0;
  selectedPrediction = null;
  prediction:Object[] = [];
  attribValidator:AbstractControl[] = [];
  @Input()  variacoes:object[] = [];
  @Input()  category_id:string="MLB247538";
  @Input()  tipo:string;
  @Input()  selectedData:object = {};
  selectedIndex:number = -1;
  @Input()  fatherAttribs: object[]=[];
  @Input()  colDef;
  face  = false;
  @Input() maindata;
  formGroupFather:UntypedFormGroup;
//  @Input()  varAttribs: object[] = [];
  @Input() images: string[] = [];

  @Output() savingVariacao:EventEmitter<boolean> = new EventEmitter();


  getOptions(value:string){
      let idata:options[] = [];
      this.colDef.forEach( l => {
          if ( l.COLUMNNAME.toUpperCase() == value.toUpperCase() ){
              if ( l.VALIDATIONERROR != null ){
                var ob:Object = JSON.parse(l.VALIDATIONERROR);
                if ( ob['type']=='select'){
                  idata = ob['options'];
                }
              }
          }
      })
      this.dataValue.set(value,idata);
  }

  afterLoad(event, nomeControle){
      
    if ( event ){
      if ( nomeControle == 'codeproductvar'){
        this.formVariacao.get(nomeControle).patchValue({id:this.selectedData['codeproductvar'],name:this.selectedData['fk_mktpmeliskuvar_2_mktpproducts->name']});
      }
    }
  }

  itemSelect(event){
    this.selectedData['codeproductvar'] = event.id; 
    this.selectedData['fk_mktpmeliskuvar_2_mktpproducts->name'] = event.name;
    this.formVariacao.get("codeproductvar").patchValue({id:this.selectedData['codeproductvar'],name:this.selectedData['fk_mktpmeliskuvar_2_mktpproducts->name']});

  }


  loadForm(){
      Object.keys(this.selectedData).forEach( key=>{
        try{
          if ( this.formVariacao.get(key) != null){
            this.formVariacao.get(key.toLowerCase()).patchValue(this.selectedData[key]);
          }else{
            this.formVariacao.addControl(key,new UntypedFormControl(this.selectedData[key]));
          }
        }catch(Exception){	
            //console.log(Exception+ " - "+key);
        }
      })
  }

  ngOnInit(): void {
    
    this.formVariacao = this.formBuilder.group({
      codeproduct:null,
      codecompany:null,
      codecontract:null,
      codemeli:null,
      codeproductvar:null,
      descrprodvar:null,
      pricevar:null,
      codtab:null,
      percquantity:null,
      codlocal:null,
      available_quantity_var:new UntypedFormControl(null,[Validators.max(99999), Validators.min(0)]),
      active:null,
      porlocal:null,
      tabpreco:null,
      //idvaricao: new FormControl({value:null,disabled:true}),
      idvaricao: new UntypedFormControl({value:null}),
      status:null,
      datavalprom:null,
      percacres:null,
      percdesconto:null,
    });
    
    this.formGroupFather = this.maindata.formGroup;
    this.varServices.changeFace(false);
    
  }

  
  add(): void {
    const value = (this.imageCtrl.value || '').trim();

    if (value) {
      this.images.push(value);
    }

    // Clear the input value
    this.imageCtrl.setValue(null);
  }

  remove(image: string): void {
    const index = this.images.indexOf(image);

    if (index >= 0) {
      this.images.splice(index, 1);
    }
  }

  finalizar(){
      if ( this.tipo =="insertFace" || this.tipo == "editFace"){
        
        Object.keys(this.formVariacao.controls).forEach((key:string)=>{
          const abstractControl = this.formVariacao.controls[key];
          if ( key == "codeproductvar" ){
            this.selectedData['codeproductvar'] = abstractControl.value.id;
            this.selectedData['fk_mktpmeliskuvar_2_mktpproducts->name'] = abstractControl.value.name;
          }else{
            if (  key != "fk_mktpmeliskuvar_2_mktpproducts->name" ){
              this.selectedData[key] = abstractControl.value;
            }
          }
          
        })

        this.selectedData['images'] = this.images;
      

        if ( this.tipo == "insertFace"){
          this.variacoes.push(this.selectedData);
        }else{
          this.variacoes[this.selectedIndex] = this.selectedData;
        }

        
        this.savingVariacao.next(true);
        this.selectedData = {};
        this.images = [];
      }
  }

  selectItem(item,index){
    
    this.oldSelectedData = Object.assign({},item);
    
    this.selectedData  = item;
    this.selectedIndex = index;
    this.images = this.selectedData['images'];
    this.varServices.changeFace('editFace');
    this.savingVariacao.next(false);
    setTimeout(()=>{
      this.loadForm();
    }, 1000);
    
  }

  selected(event): void {
    this.images.push(event.option.viewValue);
    this.imageInput.nativeElement.value = '';
    this.imageCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.allImages.filter(image => image.toLowerCase().includes(filterValue));
  }


  buscarAtributosVar(){

    this.spinner.show('meliitemcontainervariacao');
    if ( !ObjectUtil.isNotEmpty(this.category_id) ){
        this.snackBar.showError("Não informado o código de categoria.");
        this.spinner.hide('meliitemcontainervariacao');
        return;
    }

    let obvar = {
      codeCompany : this.formGroupFather.get("CODECOMPANY").value,
      method: "GET",
      serviceName: "FindAttribByCat",
    }

    obvar['params']=[{
        key:"@CATEGORYID",
        value:this.category_id
    }];

    
    //this.selectedData['attribs'] = [];
    //this.selectedAtrib = [];
    
    this.http2.post(obvar,'MeliNotifications/getGenericMeli',false,true,false).subscribe(newdata=>{
        this.attribValidator = [];    

        let tempAttrib:Object[] = newdata['resultado'];
        
        tempAttrib.forEach(a=>{
          a['id_atributo'] = a['id'];
        });


        if (  this.selectedData['attribs'] !=null  && this.selectedData['attribs'].length > 0 ){
          this.dialogService.openNewDialog("Já existem atributos carregados. Deseja limpar e carregar novamente?",(data)=>{
              if ( data ){
                  this.selectedData['attribs'] = [];
              }  
              this.loadAtributos(tempAttrib);
          },()=>{
              this.loadAtributos(tempAttrib);
          });
        }else{  
            this.loadAtributos(tempAttrib);
        }


        
      },error=>{
        this.spinner.hide('meliitemcontainervariacao');
        throw error;
      });

  }

  loadAtributos(tempAttrib){
    tempAttrib.forEach(data=>{

      let canShow = false;

      if ( ObjectUtil.isNotEmpty(data['tags']) ){
          if ( ObjectUtil.isNotEmpty(data['tags']['allow_variations'])){
            let allow_variations  = data['tags']['allow_variations'];
              if( allow_variations){
                canShow =  true;
              }else{
                canShow = false;
              }
          }else{
            canShow = false;
          }
      }else{
          canShow = false;
      }
      
      if ( canShow ){
        
        if ( this.selectedData['attribs'] != null ){
          if ( this.selectedData['attribs'].findIndex(d=>d['id_atributo']==data['id_atributo']) == -1){
            this.selectedData['attribs'].push(data)
          }
        }else{
          this.selectedData['attribs'] = [data];
        }
      }
      
      
    });

    /*
    let toDelete:string[] = [];
    let index = 0;
    
    

    
    this.selectedData['attribs'].forEach(a=>{

      let id = this.fatherAttribs.findIndex(f=> {
          return f['id_atributo'] == a['id_atributo'] && ObjectUtil.isNotEmpty(f['value_id']) && f['active']=='true'
        });

        if ( id > -1){
          toDelete.push(a['id_atributo']);
        }

        index++;
    })


    if ( toDelete.length > 0){
      
      toDelete.forEach(index=>{
          let dataIndex = this.selectedData['attribs'].findIndex(f=>f['id_atributo'] == index)
          this.selectedData['attribs'].splice(dataIndex,1);
      })
    }*/

    this.cd.markForCheck();
    this.spinner.hide('meliitemcontainervariacao');

  }

  deleteItem(ob:object, type:string, index:number, event:Event){

      event.preventDefault();
      event.stopPropagation();
      if ( type  == 'V'){
        this.variacoes.splice(index,1);        
        
      }else{
        this.selectedData['attribs'].splice(index,1);        
      }

  }


  openDataOption(item){
      

    let array =  [{
       "key":"@IDATRIBUTO",
       "value":item["id_atributo"]
     }]
     
     this.getDataFromTable(item,'value_id',"complex","{@getAttibVarValueErp}",false,null,array);
  
 }



  clear(formcontrolName:string, formControl:UntypedFormGroup , event:Event){
      event.stopPropagation();
      event.stopImmediatePropagation();
      event.preventDefault();

      formControl.get(formcontrolName).setValue('');

  }




  isRequired(item:object, type:string){

    if ( type == "A"){
      if ( item['hierarchy']=='PARENT_PK'){
        return true;
      }
    }

    return false;

  }


  
  getDataFromTable(fromControl:any, fieldName: string, event, externalExpression:string, ehArray:boolean = false, pkCheck?:string, externalParam?:Object[]){

    
    if ( externalExpression != null ){
  
      let arrayData:Object[] = [];

      if ( externalParam != null ){
        if ( externalParam.length > 0 ){
          externalParam.forEach(data=>{
            arrayData.push(data);
          })
        }
      }
      


      if ( this.formVariacao.get('codeproductvar').value == null){
        this.snackBar.showError("É preciso escolher o produto da variação para buscar dados.");
        return;
      }

      this.spinner.show('meliitemcontainervariacao');

      arrayData.push({
        'key':'@CODPRODMAIN',
        'value': this.formGroupFather.get("CODEPRODUCT").value
      });


      arrayData.push({
          'key':'@CODPROD',
          'value': this.formVariacao.get("codeproductvar").value.id
      });

      arrayData.push({
        'key':'@CODTAB',
        'value': this.formVariacao.get('codtab').value
      })

      arrayData.push({
        'key':'@CODLOCAL',
        'value': this.formVariacao.get('codlocal').value
      })

      
      Object.keys(this.formImagens.controls).forEach(control=>{
        const abstractControl = this.formImagens.controls[control];
        
        if ( abstractControl.value != null){
          arrayData.push({
            'key':'@'+control.toUpperCase(),
            'value':abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
          })
        }
      })
      
      Object.keys(this.formVariacao.controls).forEach(control=>{
        const abstractControl = this.formVariacao.controls[control];
        
        if ( abstractControl.value != null){
          arrayData.push({
            'key':'@'+control.toUpperCase(),
            'value':abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
          })
        }
      })

      let ob = {
        'expressao': externalExpression,
        'novo':true,
        'codecontract':this.formGroupFather.get("CODECONTRACT").value,
        'codecompany': this.formGroupFather.get("CODECOMPANY").value,
        'codemktp':3,
        'values':arrayData
      }

      this.http.post(ob, 'FormulaServices/test',false,true,true).subscribe(data=>{
        
        
        let resultado = data['resultado'];
        let objeto  = JSON.parse(resultado);
        let SQL:Object[] = objeto['SQL'];
        let value:string | string[] | Object[] = null;
        
        

        if ( SQL != null && SQL.length > 0 ){
          if ( !ehArray){
            value = SQL[0]['VALOR'];
          }else{
            
            if ( event =="complex"){
              (value as Object[]) = [];  
            }else{
              (value as string[]) = [];
            }
            
            SQL.forEach(data=>{
              if ( event =="complex"){
                  (value as Object[]).push(data); 
              }else{
                (value as string[]).push(data['VALOR']);
              }
              
            })
          }
           
        }
        
        if ( value != null ){
            if ( !ehArray){
              if ( fromControl instanceof UntypedFormGroup){
                (fromControl as UntypedFormGroup).get(fieldName).setValue(value);
              }else{
                if ( fromControl instanceof Object){
                  fromControl[fieldName] = value;
                }
              }
              
            }else{
              
              if ( event == "complex"){
                
                (value as object[]).forEach(data=>{
                  if ( pkCheck !=null ){
                    if ( this[fromControl as string].length > 0 ){
                      if (this[fromControl as string].findIndex(x=> x[pkCheck] == data[pkCheck])== -1 ){
                        this[fromControl as string].push(data);
                      }
                    }else{
                      this[fromControl as string].push(data);
                    }
                  }else{
                      this[fromControl as string].push(data);
                  }
                });
              }else{
                this[fromControl as string]  = [];
                (value as string[]).forEach(data=>{
                  this[fromControl as string].push(data);
                });
              }
              

            }
        }
        

        this.spinner.hide('meliitemcontainervariacao');
        this.cd.markForCheck();
      },error=>{
        this.spinner.hide('meliitemcontainervariacao');
        throw error;
      },()=>{
        this.spinner.hide('meliitemcontainervariacao');
      });

    }
  }
}
